import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap,withLatestFrom } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";
import { StatState } from "../../models/stat-state";
import { AppState } from "../../reducers";
import { StatSelectors } from "../../selectors/stats.selectors";

@Injectable()
export class StatsEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.stats.get),
			withLatestFrom(this.store.select(StatSelectors.stats)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(ConsumerActions.stats.getSuccess({ ...state, loading: false }))
					: of(ConsumerActions.stats.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.stats.getApi),
			switchMap(() =>
				this.consumerService.stats().pipe(
					map((stats) => ConsumerActions.stats.getSuccess({ stats, loading: false })),
					catchError((error) => of(ConsumerActions.stats.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService,
		private store: Store<AppState>
	) {}

	canUseStoreValue(state: StatState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
